import {
  Button,
  HStack,
  IconButton,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spacer,
  Text,
} from '@chakra-ui/react';

import { CloseCircleOutline, ExclamationCircleOutline } from '@aslanpay/portal-common-lib';

import useDeleteIndividuals from 'app/hooks/useDeleteIndividuals';

import { DeleteIndividualModalProps } from './types';

function DeleteIndividualModal({
  selectedIndividuals,
  isOpen,
  onClose,
  onDelete,
  type,
}: DeleteIndividualModalProps) {
  const title =
    selectedIndividuals.length > 1 ? `Delete the selected ${type}(s)?` : `Delete ${type}?`;

  const { mutate: deleteIndividuals, isLoading: isDeletingIndividual } = useDeleteIndividuals(
    type,
    {
      onSuccess: () => {
        onDelete();
        onClose();
      },
      onError: () => {
        onClose();
      },
    }
  );

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <HStack>
            <ExclamationCircleOutline color="system.error" boxSize="24px" />
            <Text as="h6">{title}</Text>
            <Spacer />
            <IconButton
              variant="link"
              icon={<CloseCircleOutline boxSize="30px" />}
              aria-label="Close create new admin"
              onClick={onClose}
            />
          </HStack>
        </ModalHeader>
        <ModalBody>
          <Text color="brand.mutedPurple" textStyle="body">
            {`This will delete the selected ${type}${
              selectedIndividuals.length > 1 ? '(s)' : ''
            } and you will not be able to recover it after confirm.`}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Spacer />
          <Button variant="outline" size="sm" onClick={onClose}>
            Cancel
          </Button>
          <Button
            size="sm"
            isLoading={isDeletingIndividual}
            onClick={() =>
              deleteIndividuals(
                selectedIndividuals.map((id) => ({
                  id,
                }))
              )
            }
          >
            Yes, delete
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default DeleteIndividualModal;
